exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".custom-desktop-banner video.video-js{height:calc((100vh - 210px) * .85)!important}.new-design-banner video.video-js{margin-bottom:-1px}", "", {"version":3,"sources":["/app/src/components/common/NewDesignBanner.vue"],"names":[],"mappings":"AACA,sCACE,4CAAgD,CACjD,AACD,kCACE,kBAAoB,CACrB","file":"NewDesignBanner.vue","sourcesContent":["\n.custom-desktop-banner video.video-js {\n  height: calc((100vh - 210px) * 0.85) !important;\n}\n.new-design-banner video.video-js {\n  margin-bottom: -1px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b74b60b0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/NewDesignBanner.vue
// module id = 2097
// module chunks = 13